/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : VehicleSavedLinkageCard.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Typography, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { componentStyle } from "../../../config/appTheme";
import CloseIcon from "@mui/icons-material/Close";

function VehicleSavedLinkageCard({
  savedLinkages,
  setSavedLinkages,
  entityType,
  onRemove,
}) {
  const [modifiedLinkItems, setModifiedLinkItems] = useState([]);

  useEffect(() => {
    let array = savedLinkages;
    setModifiedLinkItems(array);
  }, [savedLinkages]);
  return (
    <Box>
      {modifiedLinkItems?.map((item, index) => {
        return (
          <Box
            key={item?.id || item?.vs_id || item?.ee_id || item?.swm_id || index}
            sx={{
              mb: 2,
              ...componentStyle.font.text,
              color: "white",
              backgroundColor: "black",
              display: "flex",
              gap: 2,
              p: 1,
            }}
          >
            <IconButton
              onClick={() => {
                const updatedLinkages = savedLinkages.filter(
                  (linkage) => linkage !== item
                );
                setSavedLinkages(updatedLinkages);
                onRemove?.();
              }}
              sx={{ color: "white", ml: 1, mr: 1, mt: -1 }}
            >
              <CloseIcon />
            </IconButton>
            <Typography>{`Name: ${item?.vs_name || "-"}`}</Typography>
            <Typography>{`Description: ${item?.description}`}</Typography>
          </Box>
        );
      })}
    </Box>
  );
}

VehicleSavedLinkageCard.propTypes = {
  savedLinkages: PropTypes.array,
  setSavedLinkages: PropTypes.func,
  entityType: PropTypes.string,
  onRemove: PropTypes.func,
};

export default VehicleSavedLinkageCard;

